import styled from '@emotion/styled';
import { breakpoints } from '../../utils/const';

export const ListWrapper = styled.div`
    display: inline-grid;
    justify-items: center;
    grid-template-columns: 1fr;
`;
